import React from "react";
import logo from "./av-logo.png";
import { Link } from "react-router-dom";
import config from "./config";

const Header = () => (
  <header className="bg-white shadow-md py-4 sm:py-6">
    <div className="container mx-auto flex justify-center px-4 sm:px-6">
      <Link to="/">
        {/* <img src={logo} alt="Advantage Vidardbha 2025 Logo" style={{ maxWidth: '320px' }} /> */}
        <h1 className="text-2xl font-bold text-gray-800">
          {config.appTitle}
        </h1>
      </Link>
    </div>
  </header>
);

export default Header;
